export const DEFAULT_THREAD_ACTIVITY_FILTER = Object.freeze({
    hasChat: false,
    hasThreadMessages: false
});

export const normalizeThreadActivityFilter = value => ({
    hasChat: Boolean(value?.hasChat),
    hasThreadMessages: Boolean(value?.hasThreadMessages)
});

export const hasActiveThreadActivityFilter = value => {
    const normalized = normalizeThreadActivityFilter(value);
    return normalized.hasChat || normalized.hasThreadMessages;
};

export const buildThreadActivityFilterInput = value => {
    const normalized = normalizeThreadActivityFilter(value);

    return {
        ...(normalized.hasChat ? { hasChat: true } : {}),
        ...(normalized.hasThreadMessages ? { hasThreadMessages: true } : {})
    };
};
